
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Urchins extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://www.youtube.com/embed/ihvKwVDw8Pc'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Urchins;